var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHasEndedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 120,
    viewBox: "0 0 222 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6235_23152)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.548 75.3607C117.997 74.2076 118.082 72.935 117.776 71.7189C117.439 70.3763 116.649 69.1982 115.55 68.3767L119.698 61.4434C121.494 62.1726 123.604 61.5038 124.63 59.7879C125.657 58.0721 125.248 55.8972 123.756 54.659L127.911 47.7123C129.708 48.4416 131.817 47.7728 132.844 46.0569C133.87 44.341 133.461 42.1662 131.969 40.9279L136.124 33.9813C137.921 34.7105 140.03 34.0417 141.057 32.3259C142.083 30.61 141.675 28.4351 140.182 27.1969L144.33 20.2636C145.573 20.8432 146.985 20.9816 148.327 20.644C149.543 20.3382 150.624 19.6616 151.428 18.7203L206.953 51.9333C210.745 54.2013 211.98 59.1137 209.712 62.9054L184.045 105.815C181.777 109.607 176.865 110.842 173.073 108.574L117.548 75.3607Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.548 75.3607L116.616 74.9976L116.309 75.7851L117.035 76.2189L117.548 75.3607ZM117.776 71.7189L116.806 71.9627L116.806 71.9627L117.776 71.7189ZM115.55 68.3767L114.692 67.8634L114.229 68.6375L114.952 69.1776L115.55 68.3767ZM119.698 61.4434L120.074 60.5168L119.279 60.1944L118.839 60.93L119.698 61.4434ZM123.756 54.659L122.898 54.1456L122.458 54.8812L123.117 55.4285L123.756 54.659ZM127.911 47.7123L128.287 46.7857L127.493 46.4634L127.053 47.199L127.911 47.7123ZM131.969 40.9279L131.111 40.4146L130.671 41.1502L131.331 41.6975L131.969 40.9279ZM136.124 33.9813L136.5 33.0547L135.706 32.7324L135.266 33.468L136.124 33.9813ZM140.182 27.1969L139.324 26.6836L138.884 27.4192L139.544 27.9665L140.182 27.1969ZM144.33 20.2636L144.752 19.3572L143.935 18.9762L143.471 19.7503L144.33 20.2636ZM148.327 20.644L148.571 21.6138L148.571 21.6138L148.327 20.644ZM151.428 18.7203L151.941 17.8621L151.216 17.4282L150.667 18.0711L151.428 18.7203ZM118.48 75.7239C119.004 74.3786 119.103 72.8939 118.746 71.475L116.806 71.9627C117.061 72.9761 116.991 74.0366 116.616 74.9976L118.48 75.7239ZM118.746 71.475C118.352 69.9087 117.431 68.5343 116.149 67.5758L114.952 69.1776C115.867 69.8622 116.525 70.8439 116.806 71.9627L118.746 71.475ZM116.409 68.89L120.556 61.9567L118.839 60.93L114.692 67.8634L116.409 68.89ZM123.772 59.2746C123.003 60.5607 121.42 61.0634 120.074 60.5168L119.322 62.37C121.568 63.2818 124.205 62.4469 125.488 60.3013L123.772 59.2746ZM123.117 55.4285C124.236 56.3567 124.541 57.9885 123.772 59.2746L125.488 60.3013C126.772 58.1556 126.26 55.4377 124.394 53.8894L123.117 55.4285ZM124.614 55.1723L128.769 48.2257L127.053 47.199L122.898 54.1456L124.614 55.1723ZM127.535 48.6389C129.782 49.5508 132.418 48.7159 133.702 46.5702L131.985 45.5436C131.216 46.8297 129.634 47.3323 128.287 46.7857L127.535 48.6389ZM133.702 46.5702C134.985 44.4246 134.474 41.7067 132.608 40.1583L131.331 41.6975C132.449 42.6256 132.755 44.2575 131.985 45.5436L133.702 46.5702ZM132.827 41.4413L136.982 34.4947L135.266 33.468L131.111 40.4146L132.827 41.4413ZM135.748 34.9079C137.995 35.8198 140.632 34.9848 141.915 32.8392L140.199 31.8125C139.429 33.0987 137.847 33.6013 136.5 33.0547L135.748 34.9079ZM141.915 32.8392C143.198 30.6936 142.687 27.9757 140.821 26.4273L139.544 27.9665C140.662 28.8946 140.968 30.5264 140.199 31.8125L141.915 32.8392ZM141.041 27.7102L145.188 20.7769L143.471 19.7503L139.324 26.6836L141.041 27.7102ZM143.907 21.17C145.358 21.8462 147.005 22.0077 148.571 21.6138L148.083 19.6742C146.965 19.9555 145.788 19.8402 144.752 19.3572L143.907 21.17ZM148.571 21.6138C149.99 21.2571 151.251 20.4677 152.189 19.3694L150.667 18.0711C149.998 18.8556 149.097 19.4194 148.083 19.6742L148.571 21.6138ZM150.915 19.5785L206.44 52.7915L207.467 51.0751L151.941 17.8621L150.915 19.5785ZM206.44 52.7915C209.758 54.776 210.838 59.0744 208.854 62.3921L210.57 63.4188C213.122 59.1531 211.732 53.6266 207.467 51.0751L206.44 52.7915ZM208.854 62.3921L183.187 105.302L184.904 106.328L210.57 63.4188L208.854 62.3921ZM183.187 105.302C181.203 108.619 176.904 109.7 173.587 107.716L172.56 109.432C176.826 111.983 182.352 110.594 184.904 106.328L183.187 105.302ZM173.587 107.716L118.061 74.5026L117.035 76.2189L172.56 109.432L173.587 107.716Z",
    fill: "#C7C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.153 79.457L160.155 62.7346",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.054 86.8339L182.587 52.5063",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.068 94.0207L194.602 59.6931",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6235_23152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3933 80.9856C11.1371 79.519 10.5091 78.7857 10.0617 77.9586C9.66491 77.2249 9.37421 76.4386 9.19831 75.6232C9 74.704 9 73.7385 9 71.8075L9.00003 28.109C9.00003 23.1704 9.00003 20.701 9.96115 18.8147C10.8066 17.1555 12.1556 15.8065 13.8148 14.9611C15.7011 13.9999 18.1704 13.9999 23.1091 13.9999L113.928 13.9999C118.869 13.9999 121.34 13.9999 123.227 14.9617C124.886 15.8077 126.236 17.1575 127.081 18.8177C128.041 20.705 128.04 23.1755 128.038 28.1166L128.008 83.8985C128.005 88.8348 128.004 91.3029 127.042 93.1882C126.196 94.8465 124.847 96.1947 123.189 97.0395C121.303 98 118.835 98 113.899 98L33.4586 98C31.0706 98 29.8766 98 28.7675 97.7064C27.7847 97.4463 26.8543 97.0181 26.0173 96.4409C25.0729 95.7895 24.2962 94.8827 22.7428 93.069L12.3933 80.9856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0211 80.4478C11.7423 78.9547 11.1846 78.2969 10.7889 77.5653C10.4293 76.9004 10.1658 76.1878 10.0064 75.4489C9.83101 74.6358 9.8267 73.7734 9.8267 71.8075L9.82673 28.109C9.82673 25.626 9.82737 23.8135 9.94413 22.3846C10.0601 20.9652 10.2865 19.9972 10.6977 19.19C11.4639 17.6864 12.6865 16.4638 14.1901 15.6977C14.9973 15.2864 15.9653 15.06 17.3846 14.944C18.8136 14.8273 20.6261 14.8266 23.1091 14.8266L113.928 14.8266C116.413 14.8266 118.226 14.8273 119.656 14.9441C121.076 15.0602 122.044 15.2867 122.851 15.6982C124.355 16.4649 125.578 17.6882 126.344 19.1927C126.755 20.0003 126.981 20.9688 127.096 22.3889C127.212 23.8186 127.212 25.632 127.211 28.1161L127.181 83.8981C127.18 86.3798 127.178 88.1914 127.06 89.6197C126.944 91.0383 126.717 92.0058 126.306 92.8126C125.539 94.3154 124.317 95.5372 122.813 96.3029C122.007 96.7139 121.039 96.9401 119.62 97.056C118.192 97.1727 116.38 97.1733 113.899 97.1733L33.4586 97.1733C31.0267 97.1733 29.9598 97.1669 28.979 96.9072C28.0884 96.6715 27.2452 96.2835 26.4867 95.7604C25.6515 95.1843 24.9526 94.3783 23.3707 92.5313L13.0211 80.4478Z",
    stroke: "#C7C7CC",
    strokeWidth: 1.6534
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26 34H32",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 34H48",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 34H64",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 34H80",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 34H96",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 34H112",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 44H80",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 44H96",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 44H112",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 54H32",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 54H48",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 54H64",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 54H80",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 54H96",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 54H112",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 64H32",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 64H48",
    stroke: "#D12E34",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 64H64",
    stroke: "#D12E34",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 64H80",
    stroke: "#D12E34",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 64H96",
    stroke: "#D12E34",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 64H112",
    stroke: "#D12E34",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 74H32",
    stroke: "#D12E34",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 74H48",
    stroke: "#D12E34",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 74H64",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 74H80",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 74H96",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 74H112",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 84H32",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 84H48",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 84H64",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 84H80",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6235_23152)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 93.6748C27 95.0108 27 95.6788 26.7452 95.9635C26.5246 96.2102 26.1962 96.3317 25.8681 96.288C25.4894 96.2376 25.0547 95.7304 24.1852 94.7161L11.2639 79.6413C10.5435 78.8008 10.1834 78.3806 10.1745 78.0248C10.1669 77.7156 10.3027 77.4202 10.5425 77.2248C10.8183 77 11.3718 77 12.4788 77L12.891 77C17.8296 77 20.2989 77 22.1852 77.9611C23.8444 78.8065 25.1935 80.1556 26.0389 81.8148C27 83.7011 27 86.1704 27 91.109L27 93.6748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1733 93.6748C26.1733 94.3589 26.1725 94.8169 26.1445 95.1424C26.1296 95.3154 26.1094 95.4028 26.0999 95.4383C26.0752 95.4558 26.0464 95.4664 26.0163 95.4693C25.9859 95.4484 25.9137 95.3952 25.7899 95.2736C25.5567 95.0447 25.2581 94.6975 24.8129 94.178L11.8916 79.1033C11.5207 78.6705 11.2803 78.3888 11.1259 78.1719C11.0482 78.0628 11.0155 78.0005 11.0029 77.9739C11.0078 77.9417 11.0217 77.9116 11.0429 77.8869C11.0713 77.8792 11.1399 77.8635 11.2733 77.8515C11.5384 77.8275 11.9088 77.8267 12.4788 77.8267L12.891 77.8267C15.3739 77.8267 17.1864 77.8273 18.6154 77.9441C20.0347 78.0601 21.0027 78.2864 21.8099 78.6977C23.3136 79.4639 24.5361 80.6864 25.3023 82.1901C25.7136 82.9973 25.9399 83.9653 26.0559 85.3846C26.1727 86.8136 26.1733 88.6261 26.1733 91.109L26.1733 93.6748Z",
    stroke: "#C7C7CC",
    strokeWidth: 1.6534
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_6235_23152)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 6,
    width: 12,
    height: 19,
    rx: 2.20454,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 6,
    width: 12,
    height: 19,
    rx: 2.20454,
    stroke: "#C7C7CC",
    strokeWidth: 1.6534
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_6235_23152)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 6,
    width: 12,
    height: 19,
    rx: 2.20454,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 6,
    width: 12,
    height: 19,
    rx: 2.20454,
    stroke: "#C7C7CC",
    strokeWidth: 1.6534
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_6235_23152)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 90,
    r: 26,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 90,
    r: 26,
    stroke: "#D12E34",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M120.763 81.3052L137.237 98.695M137.237 81.3052L120.763 98.695",
    stroke: "#D12E34",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6235_23152",
    x: 4.59092,
    y: 10.6932,
    width: 127.856,
    height: 92.8182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10227
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.20454
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6235_23152"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6235_23152",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6235_23152",
    x: 5.76524,
    y: 73.6932,
    width: 25.6438,
    height: 28.115,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10227
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.20454
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6235_23152"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6235_23152",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_6235_23152",
    x: 28.7643,
    y: 1.86653,
    width: 22.4715,
    height: 29.4715,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10227
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.20454
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6235_23152"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6235_23152",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_6235_23152",
    x: 86.7643,
    y: 1.86653,
    width: 22.4715,
    height: 29.4715,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10227
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.20454
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6235_23152"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6235_23152",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_6235_23152",
    x: 98,
    y: 61,
    width: 62,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6235_23152"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6235_23152",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6235_23152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 222,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHasEndedIcon);
export default __webpack_public_path__ + "static/media/has_ended_icon.e47b52f853cb56cd0a70e04808851572.svg";
export { ForwardRef as ReactComponent };